// extracted by mini-css-extract-plugin
export default {"wrap":"info-panel__wrap__k_","button":"info-panel__button__Fg"};